import { render, staticRenderFns } from "./VoiceCall.vue?vue&type=template&id=0becdd50&scoped=true"
import script from "./VoiceCall.vue?vue&type=script&lang=js"
export * from "./VoiceCall.vue?vue&type=script&lang=js"
import style0 from "./VoiceCall.vue?vue&type=style&index=0&id=0becdd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becdd50",
  null
  
)

export default component.exports